//Use this env object 
// console.log(`Process.env = ${JSON.stringify(process.env)}`)
const env = {
    //These are the buildtime variables
    ...process.env, 
    //These are the runtime variables
    ...window?.process?.env
}

export default env;